// Constant error messages used to detect errors thrown inside web app
// (they are not coming from BE).
export enum CUSTOM_ERROR {
    no_firebase_token_found = 'No firebase token found',
    no_user_default_org_found = 'No user default org found',
    no_reset_password_token_or_email_provided = 'No reset password token or email provided',
    invalid_credentials = 'Invalid credentials',
}
